"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = exports.getLabelForSelectValue = exports.getOptionForValue = exports.getMultiSelectValues = exports.setToSelectOptions = exports.selectOptionsFromMap = void 0;
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const creatable_1 = __importDefault(require("react-select/creatable"));
const Select_pc_1 = require("./Select.pc");
const selectOptionsFromMap = (options) => Object.entries(options).map(([value, label]) => ({
    label,
    value,
}));
exports.selectOptionsFromMap = selectOptionsFromMap;
const setToSelectOptions = (values) => values.map((value) => ({
    label: value,
    value,
}));
exports.setToSelectOptions = setToSelectOptions;
// Use CreatableSelect instead of Select if isCreatable prop is true
// this will allow creation of new options
const StyledSelect = (props) => {
    const DynamicSelect = props.isCreatable
        ? creatable_1.default
        : react_select_1.default;
    return (react_1.default.createElement(Select_pc_1.Wrapper, { testId: props['data-testid'] },
        react_1.default.createElement(DynamicSelect, Object.assign({ classNamePrefix: "select" }, props))));
};
const getSelectedValuesFromSelectOption = (options) => {
    return options ? options.map((option) => option.value) : [];
};
// Get multiselect string values, useful when uploading form that has select with isMulti
const getMultiSelectValues = (data, toValues) => {
    const formattedValues = toValues
        .map((key) => ({
        [key]: getSelectedValuesFromSelectOption(data[key]),
    }))
        .reduce((acc, current) => (Object.assign(Object.assign({}, acc), current)), {});
    return Object.assign(Object.assign({}, data), formattedValues);
};
exports.getMultiSelectValues = getMultiSelectValues;
// Get entire select option object given available options and a value
const getOptionForValue = (options, value) => options.find((option) => option.value === value);
exports.getOptionForValue = getOptionForValue;
// Get label for value, this is mostly a hack, my suggestion is for us to stop wrapping constants inside setToSelect and
// do that instead on the fly inside this Select component, that will free the constant options to be able to be accessed directly – Julio
const getLabelForSelectValue = (options, value) => { var _a; return ((_a = options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label) || ''; };
exports.getLabelForSelectValue = getLabelForSelectValue;
const getDefaultValueForSelect = (options, { value, selectOneMessage, isCreatable, }) => {
    if (Array.isArray(value) && typeof value !== 'string') {
        return value;
    }
    if (isCreatable) {
        return undefined;
    }
    return ((options === null || options === void 0 ? void 0 : options.find(({ value: optionValue }) => optionValue === value)) ||
        (selectOneMessage && {
            value: '',
            label: selectOneMessage,
        }));
};
const getDefaultLabel = ({ isCreatable }) => {
    if (isCreatable) {
        return 'Select or add one';
    }
    // Undefined is useful to the inner component because we need an empty placeholder for the moving label
    return undefined;
};
const SelectInput = ({ value, options, 'aria-label': ariaLabel, 'data-testid': testId, disabled, loading, isClearable, isCreatable, isMulti, isMultiClearable, inputId, autoFocus, secondary, negative, formatCreateLabel, menuPlacement, noOptionsMessage = () => 'No options', onValueChange, ref, placeholder, onBlur, }) => {
    const selectOneMessage = getDefaultLabel({ isCreatable });
    // Helpers for grouped options
    const flattenGroupedOptions = (array) => array.reduce((acc, current) => [...acc, ...(current.options || [])], []);
    const isGroupedOptions = (array) => Array.isArray(array) && array.length > 0 && !!array[0].options;
    // Map formik "initialValue" to styled select "defaultValue" + "value"
    // actual value is called "internalValue" here to avoid shadowing "value"
    const defaultValueOrEmpty = getDefaultValueForSelect(options, {
        value,
        selectOneMessage,
        isCreatable,
    });
    let internalValue;
    if (isMulti && Array.isArray(value)) {
        internalValue = options === null || options === void 0 ? void 0 : options.filter((option) => value === null || value === void 0 ? void 0 : value.some((v) => v.value === option.value));
    }
    else if (value) {
        if (options && isGroupedOptions(options)) {
            internalValue = flattenGroupedOptions(options).find(({ value: optionValue }) => optionValue === value);
        }
        else {
            internalValue = options === null || options === void 0 ? void 0 : options.find(({ value: optionValue }) => optionValue === value);
        }
    }
    else {
        internalValue = value;
    }
    return (react_1.default.createElement(StyledSelect, { ref: ref, "aria-label": ariaLabel, "data-testid": testId, options: options, menuPlacement: menuPlacement, autoFocus: autoFocus, placeholder: placeholder, defaultValue: defaultValueOrEmpty, value: internalValue, onChange: (change) => {
            // onChange may or may not exist, don't trigger react-select onChange if it doesn't
            if (!onValueChange)
                return;
            if (change) {
                // when option is creatable (i.e. not an actual option change will be string)
                if (typeof change === 'string' || isMulti) {
                    onValueChange(change);
                }
                else {
                    // else it is an actual SelectOption, we need it's value to continue
                    onValueChange(change.value);
                }
            }
            else {
                // when react-select is clearable (prop isClearable) change will be null
                onValueChange(isMultiClearable ? [] : null);
            }
        }, isDisabled: disabled, isClearable: isClearable, isCreatable: isCreatable, isMulti: isMulti, isLoading: loading, formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, inputId: inputId, secondary: secondary, negative: negative, onBlur: onBlur, v3: true }));
};
exports.SelectInput = SelectInput;
//# sourceMappingURL=Select.js.map